import { defaultIsOptionEqualToValue } from "../utils/defaultIsOptionEqualToValue.js";
const DEFAULT_VIRTUAL_LIST_BUFFER = 20;
function defaultGetItemHeights() {
  return 52;
}
function defaultGetOptionLabel() {
  return "";
}
function getDefaultState() {
  return {
    props: {
      value: null,
      items: [],
      label: "",
      density: "normal",
      getLabel: () => "",
      listMode: "normal",
      disabled: false,
      required: false,
      optionMode: "normal",
      matchFilter: void 0,
      getOptionDisabled: () => false,
      disableClearOnBlur: false
    },
    state: {
      visibleOptions: [],
      selectableOptions: [],
      selectedOption: null
    },
    actions: {
      onChange: () => {
      }
    },
    buffer: DEFAULT_VIRTUAL_LIST_BUFFER,
    searchState: ["", () => ""],
    filterOptions: (options, _state) => options,
    getOptionLabel: defaultGetOptionLabel,
    getItemHeights: defaultGetItemHeights,
    isOptionEqualToValue: defaultIsOptionEqualToValue
  };
}
export {
  DEFAULT_VIRTUAL_LIST_BUFFER,
  defaultGetItemHeights,
  getDefaultState
};
//# sourceMappingURL=utils.js.map
